const initialVillage = {
    villagePermissions:{},
    villageLists: [],
    villageStatus: [],
    changedVillageStatus : [],
    loadingVillage: false,
    errorsVillage: {}
}

const  villageReducer = (state = initialVillage, action) => {
    switch (action.type) {
        case "GET_VILLAGELIST_PENDING":
        case "ADD_VILLAGE_PENDING":
        case "UPDATE_VILLAGE_PENDING":
        case "UPDATE_VILLAGE_STATUS_PENDING":
        case "DELETE_VILLAGE_PENDING":
        case "GET_VILLAGELISTBYID_PENDING":
            return { ...state, loadingVillage: true };

        case "GET_VILLAGELIST_FULFILLED":
            return {
                ...state,
                loadingVillage: false,
                villageLists: action.payload,
                villageCount: action.villageCount,
                villagePermissions:action.permissions,
            };

        case "ADD_VILLAGE_FULFILLED":
            return {
                ...state,
                loadingVillage: false,
                changedVillageStatus: action.payload,
            };

        case "UPDATE_VILLAGE_FULFILLED":
            return {
                ...state,
                loadingVillage: false,
                changedVillageStatus: action.payload,
            };

        case "UPDATE_VILLAGE_STATUS_FULFILLED":
                return {
                    ...state,
                    loadingVillage: false,
                    changedVillageStatus: action.payload,
                };

        case "GET_VILLAGELISTBYID_FULFILLED":
            return {
                ...state,
                loadingVillage: false,
                villageLists: action.payload
            };

        case "DELETE_VILLAGE_FULFILLED":
            return {
                ...state,
                loadingVillage: false,
                changedVillageStatus: action.payload
            };

        case "RESET_DELETE_VILLAGE_STATUS":
            return {
                ...state,
                loadingVillage: false,
                changedVillageStatus: [],
                errorsVillage:{}
            };

        case "GET_VILLAGELIST_REJECTED":
        case "ADD_VILLAGE_REJECTED":
        case "UPDATE_VILLAGE_REJECTED":
        case "UPDATE_VILLAGE_STATUS_REJECTED":
        case "DELETE_VILLAGE_REJECTED":
        case "GET_VILLAGELISTBYID_REJECTED":
            return {
                ...state,
                loadingVillage: false,
                errorsVillage: action.payload
            };

        default:
            return state;
    }
}

export default villageReducer;